// extracted by mini-css-extract-plugin
export var divider = "_xc-0";